import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { responseHandler, sendData, socket } from "../../../store/actions";
import LayoutV2 from "../../../components/layout-v2";
import UInput from "ubs-framework/v2/UInput";
import * as Icon from "ubs-icons"
import Validator from "simple-react-validator";
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import useSocket from "../../common/useSocket";
import { withRouter } from "../../../common/hocs/routing-hoc";
import Select from "react-select";
import { getLabelValue } from "ubs-framework/v2/common/function";
import UCountryMobile from "ubs-framework/v2/UCountryMobile";
import { showToastSuccess, spiltContact } from "ubs-framework/v2/common/function";
import { getCookie } from "ubs-framework/v2/common/function";
import { constant, SIGNUP_STEPS, SLUG_TYPE } from "../../../common/constant";
import ct from "countries-and-timezones";
import GTMHandler from "../../common/components/gtm-handler";

import { TEST_ID } from "ubs-framework/v2/test-ids/account-testids";

const SUBDOMAIN_LP_QUERY_KEY = "subdomainlp";
const SUBDOMAIN_LP_SESSION_KEY = "track_signup_subdomainlp";
const REMOVE_SUBDOMAIN_LP_GTM_ON_UNMOUNT = [];
const PARAMETER_PATH_QUERY_KEY = "parameter_path";
const PARAMETER_PATH_SESSION_KEY = "track_signup_parameter_path";
const PARAMETER_PATH_GTM_TARGET = "employee-track-software-india";
const REMOVE_PARAMETER_PATH_GTM_ON_UNMOUNT = [];

const CompanyDetails = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const forceUpdate = useForceUpdate()
    const validator = useRef(new Validator({
        element: (message, className) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: { forceUpdate }
    }));

    const [countryOptions, setCountryOptions] = useState([]);
    const [errorMsg, setErrorMsg] = useState("");
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [companyDetail, setCompanyDetail] = useState({
        company: "",
        country: "",
    });
    const isSubdomainLpFlow = new URLSearchParams(props.location.search).get(SUBDOMAIN_LP_QUERY_KEY) === "true" || sessionStorage.getItem(SUBDOMAIN_LP_SESSION_KEY) === "true";
    const isParameterPathGtmFlow = new URLSearchParams(props.location.search).get(PARAMETER_PATH_QUERY_KEY) === PARAMETER_PATH_GTM_TARGET || sessionStorage.getItem(PARAMETER_PATH_SESSION_KEY) === PARAMETER_PATH_GTM_TARGET;

    
    // const tz = moment.tz.guess();
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const tzInfo = ct.getTimezone(tz);


    useEffect(() => {
        const countries = tzInfo?.countries?.map(code => ct.getCountry(code).name);
        const country = constant.COUNTRY_CODE?.find(_ => _.label === countries[0]);
        setCompanyDetail({...companyDetail, country: countryOptions?.find(_ => _.label === country?.label)});
    }, [tz, countryOptions]);

    useEffect(() => {
        if (new URLSearchParams(props.location.search).get(SUBDOMAIN_LP_QUERY_KEY) === "true") {
            sessionStorage.setItem(SUBDOMAIN_LP_SESSION_KEY, "true");
        }
        const parameterPath = new URLSearchParams(props.location.search).get(PARAMETER_PATH_QUERY_KEY);
        if (parameterPath) {
            sessionStorage.setItem(PARAMETER_PATH_SESSION_KEY, parameterPath);
        }
    }, [props.location.search]);

    const {on, off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'addressParams':
                    if (res?.data?.results?.length) {
                        if (res.data?.type === 'country') {
                            setCountryOptions(getLabelValue(res?.data?.results))
                        }
                    }
                    break;
                case 'account|signUp|createCompany': {
                    const slugType = localStorage.getItem('slugType') || 'track'
                    showToastSuccess(res?.data?.message || 'Company Details added successfully')
                    if (res?.data?.signUpStep) {
                        localStorage.setItem('signUpStep', res?.data?.signUpStep)
                    }
                    if (res?.data?.orgInfo?.orgId) {
                        localStorage.setItem('signUpOrgId', res?.data?.orgInfo?.orgId)
                    }
                    if ([1]?.includes(res?.data?.signUpStep)) history.push(`/${slugType}/${SIGNUP_STEPS?.[res?.data?.signUpStep]}?email=${res?.data?.email}`)
                    else if ([2]?.includes(res?.data?.signUpStep)) history.push(`/${slugType}/${SIGNUP_STEPS?.[res?.data?.signUpStep]}`)
                    else if ([3, 4]?.includes(res?.data?.signUpStep)) history.push(`/${res?.data?.orgInfo?.orgId}/${slugType}/${SIGNUP_STEPS?.[res?.data?.signUpStep]}`)
                    break;
                }
                default:
                    return true;
            }
        }
    })

    useEffect(() => {
        on();
        return () => off()
    }, [])

    useEffect(() => {
        sendData(dispatch, 'addressParams', {})
        socket.on("response", (response) => {
            let res = responseHandler(response);
            if (!res.error) {
                setDisabledBtn(false)
                switch (res.event) {
                   
                    default:
                        return true;
                }
            } else {
                setDisabledBtn(false)
                setErrorMsg(res.data.error);
                setTimeout(() => setErrorMsg(res.data.error), 5000);
            }
        });
    }, []);

    const inputEvent = (e) => {
        let { name, value } = e.target
        setCompanyDetail((val) => {
            return { ...val, [name]: value }
        })
    }

    const handle = {
        select: (e, name) => {
            const country = constant.COUNTRY_CODE.find(_ => _.label === e.label);
            setCompanyDetail({...companyDetail, [name]: e});
        },
    }

    const onSubmitAboutCompany = () => {

        if (validator?.current?.allValid()) {
            setDisabledBtn(true);
            sendData(dispatch, 'account|signUp|createCompany', {
                company: companyDetail?.company,
                country: companyDetail?.country?.value,
                countryName: companyDetail?.country?.label,
                token: getCookie('signup_token'),
                apps: [localStorage.getItem('slugType') || SLUG_TYPE?.SUPERTRACK]
            })
        } else {
            validator?.current?.showMessages()
        }
    };

    return (
        <React.Fragment>
            <GTMHandler />
            {isSubdomainLpFlow && (
                <GTMHandler
                    containerId="GTM-5BDQGFHC"
                    scriptId="subdomainlp-gtm-script-tag"
                    noscriptId="subdomainlp-gtm-noscript-tag"
                    cleanupRoutes={REMOVE_SUBDOMAIN_LP_GTM_ON_UNMOUNT}
                />
            )}
            {isParameterPathGtmFlow && (
                <GTMHandler
                    containerId="GTM-55SSBLLR"
                    scriptId="parameter-path-gtm-script-tag"
                    noscriptId="parameter-path-gtm-noscript-tag"
                    cleanupRoutes={REMOVE_PARAMETER_PATH_GTM_ON_UNMOUNT}
                />
            )}
            <LayoutV2 module="companyDetails">
                <div className="u_p-24">
                    <div>
                        <div className="u_flex u_content-center">
                            <img src="/images/images/track-logo.png"/>
                        </div>
                        <h4 className="u_title u_text-center u_text-bold u_mt-16 u_mb-24">Create a new account</h4>
                    </div>

                    <div className="u_row">
                        <div className="u_col-12">
                            <UInput
                                hasError={validator?.current?.message("company", companyDetail?.company, "required|between:1,100,string")}
                                className="u_mb-20"
                                label="Company Name"
                                asterisk
                                testId={TEST_ID.COMPANY_DETAILS.INPUT_WRAPPER}>
                                <input
                                    name="company"
                                    value={companyDetail?.company}
                                    onChange={inputEvent}
                                    placeholder=" "
                                    autoComplete="off"
                                    data-testid={TEST_ID.COMPANY_DETAILS.COMPANY_INPUT} />
                            </UInput>
                        </div>
                        <div className="u_col-12">
                            <UInput
                                hasError={validator?.current?.message("country", companyDetail?.country, "required")}
                                label="Country"
                                className="u_mb-20"
                                selectValue={companyDetail?.country}
                                select
                                asterisk
                                testId={TEST_ID.COMPANY_DETAILS.INPUT_WRAPPER}>
                                <Select
                                    className="u_input-select-inner"
                                    classNamePrefix="u_select"
                                    options={countryOptions}
                                    placeholder=" "
                                    value={companyDetail?.country}
                                    name='country'
                                    onChange={(e) => handle?.select(e, 'country')}
                                    maxMenuHeight={120}
                                />
                            </UInput>
                        </div>
                    </div>


                    {errorMsg.length !== 0 && (
                        <p className="u_error-message u_mb-15">{errorMsg}</p>
                    )}

                    <div className="u_block u_relative">
                        <button
                            disabled={disabledBtn}
                            type="button"
                            onClick={onSubmitAboutCompany}
                            className={`u_acc-btn u_w-full u_cp ${disabledBtn && 'u_white'}`}
                            data-testid={TEST_ID.COMPANY_DETAILS.BUTTON}>Continue
                        </button>
                        {disabledBtn &&
                            <div className="u_btn-loader"><Icon.Preloader size={70} /></div>}
                    </div>
                </div>
            </LayoutV2>
        </React.Fragment>
    );
}

export default withRouter(CompanyDetails);
